module.exports = __webpack_public_path__ + "img/rule2.35438849.jpg";